import React, { useState, useRef, useEffect, useContext } from 'react';

import ReactCrop, {
  centerCrop,
  Crop,
  makeAspectCrop,
  PercentCrop,
  // Crop,
  // PixelCrop,
} from 'react-image-crop';
// import { canvasPreview } from './canvasPreview.tsx';
// import { useDebounceEffect } from '../useDebounceEffect.tsx';
import styles from './style.module.css';
import Toggle from '@/components/common/Toggle';

import 'react-image-crop/dist/ReactCrop.css';
// import { LayoutContext } from '@/context/LayoutContext.js';
import VideoVolumeBar from '@/components/common/VideoVolumBar';
import Button from '@/components/common/Button';
import { canvasPreview } from './canvasPreview';
import { useDebounceEffect } from '../useDebounceEffect';
// import { canvasPreview } from './canvasPreview.jsx';

function centerAspectCrop(mediaWidth: number, mediaHeight: number, aspect: number) {
  return centerCrop(
    makeAspectCrop({ unit: '%', width: 90 }, aspect, mediaWidth, mediaHeight),
    mediaWidth,
    mediaHeight,
  );
}

type CropImageProps = {
  previewImage: File | null;
  setSelectedFile: (file: File | Blob | string | null) => void;
  className?: string;
  handleShowModal: () => void;
  showToggle?: boolean;
  suitableAspect?: number; // e.g. 16/9
};

export default function CropImage({
  previewImage,
  setSelectedFile,
  className,
  handleShowModal,
  showToggle = false,
  suitableAspect = 16 / 9,
}: CropImageProps) {
  const [imgSrc, setImgSrc] = useState<string>('');

  const previewCanvasRef = useRef<HTMLCanvasElement | null>(null);
  const imgRef = useRef<HTMLImageElement | null>(null);

  const [crop, setCrop] = useState<PercentCrop | undefined>(undefined);
  const [completedCrop, setCompletedCrop] = useState<Crop | undefined>(undefined);

  const [scale, setScale] = useState<number>(1);
  const [rotate, setRotate] = useState<number>(0);
  const [aspect, setAspect] = useState<number | undefined>(suitableAspect);

  useEffect(() => {
    if (previewImage) {
      setCrop(undefined);

      const reader = new FileReader();
      reader.addEventListener('load', () => {
        setImgSrc(reader.result?.toString() || '');
      });

      if (typeof previewImage === 'string') {
        setImgSrc(previewImage);
        return;
      }

      reader.readAsDataURL(previewImage as Blob);
    }
  }, [previewImage]);

  function onImageLoad(e: React.SyntheticEvent<HTMLImageElement>) {
    if (aspect && imgRef.current) {
      const { width, height } = imgRef.current;
      setCrop(centerAspectCrop(width, height, aspect) as unknown as PercentCrop);
    }
  }

  useDebounceEffect(
    async () => {
      if (
        completedCrop?.width &&
        completedCrop?.height &&
        imgRef.current &&
        previewCanvasRef.current &&
        previewImage
      ) {
        const { blob: croppedBlob } = await canvasPreview(
          imgRef.current,
          previewCanvasRef.current,
          completedCrop,
          scale,
          rotate,
          previewImage,
        );

        setSelectedFile(croppedBlob);
      }
    },
    100,
    [completedCrop, scale, rotate],
  );

  function handleToggleAspectClick() {
    if (aspect) {
      setAspect(undefined);
    } else if (imgRef.current) {
      const { width, height } = imgRef.current;
      setAspect(suitableAspect);
      setCrop(centerAspectCrop(width, height, suitableAspect) as unknown as PercentCrop);
    }
  }

  return (
    <div className={`App ${styles.wrapperClassName} ${className ?? ''}`}>
      <div className={`${styles.CropControls} `}>
        <div>
          <label htmlFor="scale-input">بزرگنمایی: </label>

          <VideoVolumeBar
            className={`e-range-volume e-range-volume-crop `}
            id="scale-input"
            type="range"
            min="1"
            max="10"
            step="0.1"
            value={scale}
            // disabled={!imgSrc}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setScale(Number(e.target.value))}
          />
        </div>

        <div>
          <label htmlFor="rotate-input">چرخش: </label>

          <VideoVolumeBar
            className={`e-range-volume e-range-volume-crop `}
            id="rotate-input"
            type="range"
            min="1"
            max="180"
            value={rotate}
            // disabled={!imgSrc}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setRotate(Math.min(180, Math.max(-180, Number(e.target.value))))
            }
          />
        </div>

        {showToggle && (
          <div>
            <button className={`${styles.text} `} type="button">
              <span className={`${styles.toggleText} `}>تغییر نسبت:</span>

              <Toggle
                state={!aspect}
                onClick={handleToggleAspectClick}
                // width="w-38px"
                // height="h-18px"
                // circleWidth="w-18px"
                // circleHeight="h-18px"
                // deactivePadding={dir === 'ltr' ? 'pl-22px' : 'pr-22px'}
              />
            </button>
          </div>
        )}

        <Button
          className={styles.button}
          onClick={() => {
            setSelectedFile(imgSrc);
            handleShowModal();
          }}
          type="button"
        >
          آپلود
        </Button>
      </div>

      {!!imgSrc && (
        <div className={styles.cropContainer}>
          <ReactCrop
            crop={crop}
            onChange={(_, percentCrop) => setCrop(percentCrop)}
            onComplete={(c) => setCompletedCrop(c)}
            aspect={aspect}
          >
            <img
              ref={imgRef}
              alt="Crop me"
              src={imgSrc}
              style={{ transform: `scale(${scale}) rotate(${rotate}deg)` }}
              onLoad={onImageLoad}
            />
          </ReactCrop>
        </div>
      )}

      <div>
        {!!completedCrop && (
          <canvas
            ref={previewCanvasRef}
            style={{
              border: '1px solid black',
              objectFit: 'contain',
              width: completedCrop.width,
              height: completedCrop.height,
              opacity: 0,
              // width: 0,
              // height: 0,
            }}
          />
        )}
      </div>
    </div>
  );
}

// import AppImage from '../../AppImage/index.js';

// This is to demonstate how to make and center a % aspect crop
// which is a bit trickier so we use some helper functions.
// function centerAspectCrop(mediaWidth, mediaHeight, aspect) {
//   return centerCrop(
//     makeAspectCrop(
//       {
//         unit: '%',
//         width: 90,
//       },
//       aspect,
//       mediaWidth,
//       mediaHeight,
//     ),
//     mediaWidth,
//     mediaHeight,
//   );
// }

// export default function CropImage({
//   previewImage,
//   setSelectedFile,
//   className,
//   handleShowModal,
//   showToggle = false,
//   suitableAspect = 16 / 9,
// }) {
//   const [imgSrc, setImgSrc] = useState(previewImage);
//   const previewCanvasRef = useRef(null);
//   const imgRef = useRef(null);
//   const [crop, setCrop] = useState();
//   const [completedCrop, setCompletedCrop] = useState();
//   const [scale, setScale] = useState(1);
//   const [rotate, setRotate] = useState(0);
//   const [aspect, setAspect] = useState(suitableAspect);
//   const { dir } = useContext(LayoutContext);

//   useEffect(() => {
//     if (previewImage) {
//       setCrop(undefined);
//       const reader = new FileReader();
//       reader.addEventListener('load', () => setImgSrc(reader.result?.toString() || ''));
//       reader.readAsDataURL(previewImage);
//     }
//   }, [previewImage]);

//   function onImageLoad(e) {
//     if (aspect) {
//       const { width, height } = e.currentTarget;
//       setCrop(centerAspectCrop(width, height, aspect));
//     }
//   }

//   useDebounceEffect(
//     async () => {
//       if (
//         completedCrop?.width &&
//         completedCrop?.height &&
//         imgRef.current &&
//         previewCanvasRef.current
//       ) {
//         const {
//           blob: croppedBlob,
//           blobUrl,
//           revokeUrl,
//         } = await canvasPreview(
//           imgRef.current,
//           previewCanvasRef.current,
//           completedCrop,
//           scale,
//           rotate,
//           previewImage,
//         );
//         previewImage = croppedBlob;
//       }
//     },
//     100,
//     [completedCrop, scale, rotate],
//   );

//   function handleToggleAspectClick() {
//     if (aspect) {
//       setAspect(undefined);
//     } else if (imgRef.current) {
//       const { width, height } = imgRef.current;
//       setAspect(suitableAspect);
//       setCrop(centerAspectCrop(width, height, suitableAspect));
//     }
//   }

//   console.log('croped', completedCrop, previewCanvasRef.current);
//   return (
//     <div className={`App ${styles.wrapperClassName} ${className}`}>
//       <div className={`${styles.CropControls} ${styles[dir]}`}>
//         <div>
//           <label htmlFor="scale-input">{'بزرگنمایی'}: </label>

//           <VideoVolumeBar
//             className={`e-range-volume e-range-volume-crop `}
//             id="scale-input"
//             type="range"
//             min="1"
//             max="10"
//             step="0.1"
//             value={scale}
//             disabled={!imgSrc}
//             onChange={(e) => setScale(Number(e.target.value))}
//           />
//         </div>
//         <div>
//           <label htmlFor="rotate-input">{'چرخش'}: </label>

//           <VideoVolumeBar
//             className={`e-range-volume e-range-volume-crop `}
//             id="rotate-input"
//             type="range"
//             min="1"
//             max="180"
//             value={rotate}
//             disabled={!imgSrc}
//             onChange={(e) => setRotate(Math.min(180, Math.max(-180, Number(e.target.value))))}
//           />
//         </div>

//         {showToggle && (
//           <div>
//             <button className={`${styles.text} ${styles[dir]}`}>
//               <span className={`${styles.toggleText} ${styles[dir]}`}>تغییر نسبت:</span>
//               <Toggle
//                 state={!aspect}
//                 onClick={handleToggleAspectClick}
//                 width={`w-38px`}
//                 height={`h-18px`}
//                 circleWidth={`w-18px`}
//                 circleHeight={`h-18px`}
//                 deactivePadding={`${dir == 'ltr' ? 'pl-22px' : 'pr-22px'} `}
//               />
//             </button>
//           </div>
//         )}
//         <Button
//           className={styles.button}
//           onClick={() => {
//             setSelectedFile(previewImage);
//             handleShowModal();
//           }}
//         >
//           {' '}
//           {`آپلود`}
//         </Button>
//       </div>
//       {!!imgSrc && (
//         <div className={styles.cropContainer}>
//           <ReactCrop
//             crop={crop}
//             onChange={(_, percentCrop) => setCrop(percentCrop)}
//             onComplete={(c) => setCompletedCrop(c)}
//             aspect={aspect}
//           >
//             <img
//               ref={imgRef}
//               alt="Crop me"
//               src={imgSrc}
//               style={{ transform: `scale(${scale}) rotate(${rotate}deg)` }}
//               onLoad={(e) => {
//                 onImageLoad(e);
//               }}
//             />
//           </ReactCrop>
//         </div>
//       )}
//       <div>
//         {!!completedCrop && (
//           <canvas
//             ref={previewCanvasRef}
//             style={{
//               border: '1px solid black',
//               objectFit: 'contain',
//               width: completedCrop.width,
//               height: completedCrop.height,
//               opacity: 0,
//               width: 0,
//               height: 0,
//             }}
//           />
//         )}
//       </div>
//     </div>
//   );
// }
